import { stringifyWithForcedFloatFields } from "../../analytics/transports/json_float_stringify.js";
import { ToServerCommand } from "../constants.js";

export class MessageWriter
{
  public static serializeMessage( command: ToServerCommand, body: object | null ): ArrayBuffer
  {
    const body_bytes = body === null
      ? new Uint8Array( 0 )
      : new TextEncoder().encode( stringifyWithForcedFloatFields( body ) );

    if ( body_bytes.length > 0xffff )
      throw new Error( `WebSocket message body is too large: ${body_bytes.length} bytes` );

    const buffer = new ArrayBuffer( 4 + body_bytes.length );
    const view = new DataView( buffer );
    view.setUint16( 0, command, true );
    view.setUint16( 2, body_bytes.length, true );
    new Uint8Array( buffer, 4 ).set( body_bytes );
    return buffer;
  }
}
